module.exports = __webpack_public_path__ + "static/media/ticket-img2.2c3dd82e.png";